import { arrayToMultiParam } from '../parameterManagement';

export default class LauncherResources {
    static TYPE_OPTION = "type";
    static BUILD_TOOL_OPTION = "build";
    static TEST_OPTION = "test";
    static APPLICATION_VERSION_OPTION = "version";
    static MICRONAUT_VERSION_OPTION = "micronautVersion";
    static JAVA_VERSION_OPTION = "jdkVersion";
    static LANGUAGE_OPTION = "lang";
    static CLOUDS_OPTION = "clouds";
    static SERVICES_OPTION = "services";
    static FEATURES_OPTION = "features";

    constructor(baseUrl) {
        if (this.constructor === LauncherResources) {
            throw new Error("Class LauncherResources is abstract and can't be instantiated.");
        }
    }

    /**
     * Get the supported values for an option
     * @returns object of form {options, defaultValue}
     *      options - an array of objects of form {value, label}
     *      defaultValue - value of the default option when only one value can be selected
     *                   - a multi param value when multiple values can be selected
     */
    async getOptionValues(option) {
        throw Error("Method getOptionValues() was not implemented");
    }

    /*
     * Returns default value for an option
     * This is a private method and should be used by subclasses
     */
    _getDefaultValueForOption(option) {
        switch (option) {
            case LauncherResources.CLOUDS_OPTION:
                return arrayToMultiParam(["OCI", "AWS"]);
            case LauncherResources.SERVICES_OPTION:
                return arrayToMultiParam(["DATABASE", "LOGGING", "METRICS", "SECURITY", "TRACING"]);
            case LauncherResources.FEATURES_OPTION:
                return arrayToMultiParam(["graalvm"]);
            default:
                return null;
        }
    }
}
